import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  projectsListRequest: [],
  projectsListSuccess: ['listData'],
  projectsListFailure: ['listError'],

  projectsCreateRequest: ['createParams'],
  projectsCreateSuccess: ['createData'],
  projectsCreateFailure: ['createError'],

  projectsUpdateRequest: ['id', 'updateParams'],
  projectsUpdateSuccess: ['updateData'],
  projectsUpdateFailure: ['updateError'],

  projectsDeleteRequest: ['id'],
  projectsDeleteSuccess: ['deleteData'],
  projectsDeleteFailure: ['deleteError']
})

export const ProjectTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  listData: [],
  listFetching: null,
  listError: null,

  createData: [],
  createFetching: null,
  createError: null,

  updateData: [],
  updateFetching: null,
  updateError: null,

  deleteData: [],
  deleteFetching: null,
  deleteError: null
})

/* ------------- Reducers ------------- */

export const listRequest = (state) =>
  state.merge({ listFetching: true, listError: null })

export const listSuccess = (state, { listData }) => {
  return state.merge({ listFetching: false, listData })
}

export const listFailure = (state, { listError }) =>
  state.merge({ listFetching: false, listError })

export const createRequest = (state) =>
  state.merge({ createFetching: true, createError: null })

export const createSuccess = (state, { createData }) =>
  state.merge({ createFetching: false, createData })

export const createFailure = (state, { createError }) =>
  state.merge({ createFetching: false, createError })

export const updateRequest = (state) =>
  state.merge({ updateFetching: true, updateError: null })

export const updateSuccess = (state, { updateData }) =>
  state.merge({ updateFetching: false, updateData })

export const updateFailure = (state, { updateError }) =>
  state.merge({ updateFetching: false, updateError })

export const deleteRequest = (state) =>
  state.merge({ deleteFetching: true, deleteError: null })

export const deleteSuccess = (state, { deleteData }) =>
  state.merge({ deleteFetching: false, deleteData })

export const deleteFailure = (state, { deleteError }) =>
  state.merge({ deleteFetching: false, deleteError })

export const reset = (state) => state.merge(INITIAL_STATE)

/* ------------- Selectors ------------- */

export const ProjectSelectors = {
  projectsList: state => state.projects.listData
}

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.PROJECTS_LIST_REQUEST]: listRequest,
  [Types.PROJECTS_LIST_SUCCESS]: listSuccess,
  [Types.PROJECTS_LIST_FAILURE]: listFailure,

  [Types.PROJECTS_CREATE_REQUEST]: createRequest,
  [Types.PROJECTS_CREATE_SUCCESS]: createSuccess,
  [Types.PROJECTS_CREATE_FAILURE]: createFailure,

  [Types.PROJECTS_UPDATE_REQUEST]: updateRequest,
  [Types.PROJECTS_UPDATE_SUCCESS]: updateSuccess,
  [Types.PROJECTS_UPDATE_FAILURE]: updateFailure,

  [Types.PROJECTS_DELETE_REQUEST]: deleteRequest,
  [Types.PROJECTS_DELETE_SUCCESS]: deleteSuccess,
  [Types.PROJECTS_DELETE_FAILURE]: deleteFailure
})



// WEBPACK FOOTER //
// ./src/Redux/ProjectRedux.js